import request from "./request";
import QS from 'qs';

const GET = (url, params) => {
  return new Promise((resolve, reject) => {
    request({ url, method: "get", data: params })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const POST = (url, params) => {
  return new Promise((resolve, reject) => {
    request({ url, method: "post", data: QS.stringify(params) })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const postFile = (url, params) => {
  return new Promise((resolve, reject) => {
    request({ url, method: "post", data: params, })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const postJson = (url, params) => {
  return new Promise((resolve, reject) => {
    request({ url, method: "post", data: params, headers: { 'Accept': '*/*', 'Content-Type': 'application/json' } })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

const postBlob = (url, params) => {
  return new Promise((resolve, reject) => {
    request({ url, method: "post", data: QS.stringify(params)},{
      headers: { 'Accept': '*/*', 'Content-Type': 'application/json' },
      responseType: 'blob'
    } )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export { GET, POST, postFile,postBlob,postJson };
